export default __webpack_public_path__ + "static/media/381.821d4093.jpg";